import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamationTriangleMini = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.26756 2.00196C7.03734 0.668618 8.96248 0.668618 9.73226 2.00196L14.635 10.5008C15.4038 11.834 14.4415 13.5 12.9032 13.5H3.09658C1.55793 13.5 0.59509 11.8343 1.36481 10.5008C1.36478 10.5008 1.36484 10.5007 1.36481 10.5008L6.26756 2.00196ZM7.13359 2.50195L2.23101 11.0005C1.84622 11.667 2.32728 12.5 3.09658 12.5H12.9032C13.6716 12.5 14.1533 11.6672 13.7688 11.0004L8.86623 2.50195C8.48134 1.83529 7.51848 1.83529 7.13359 2.50195ZM7.99991 5.49995C8.27605 5.49995 8.49991 5.72381 8.49991 5.99995V8.49995C8.49991 8.7761 8.27605 8.99995 7.99991 8.99995C7.72377 8.99995 7.49991 8.7761 7.49991 8.49995V5.99995C7.49991 5.72381 7.72377 5.49995 7.99991 5.49995ZM7.49991 10.5C7.49991 10.2238 7.72377 9.99995 7.99991 9.99995H8.00457C8.28072 9.99995 8.50457 10.2238 8.50457 10.5V10.5053C8.50457 10.7814 8.28072 11.0053 8.00457 11.0053H7.99991C7.72377 11.0053 7.49991 10.7814 7.49991 10.5053V10.5Z",
		fill: "currentcolor"
	})]
});
export default SvgExclamationTriangleMini;
